export default {"src":"/_next/static/media/aura-profile.0a938177.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};